module.exports = __webpack_public_path__ + "static/media/logo_trans.30224aeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_trans.png
// module id = 136
// module chunks = 1